import {useMemo} from 'react';

import {combinedFilter} from '../../../state/graphql/runSelectorQuery';
import {CustomRunNames} from '../../../state/views/customRunNames/types';
import {Filter} from '../../../util/filterTypes';
import {Key} from '../../../util/runTypes';
import {RunSetConfig} from '../../../util/section';
import {GroupSelectionState} from '../../../util/selectionmanager';

type UseCombinedFilterOptions = {
  userFilters: Filter<Key>;
  groupSelection: GroupSelectionState;
  mergeFilters: Filter<Key> | undefined;
  search: RunSetConfig['search'];
  customRunNames: CustomRunNames | undefined;
};

/**
 * Wrapper for `combinedFilter` that memoizes the result for a set of inputs.
 *
 * `combinedFilter` takes a list of user filters and combines them, returning
 * a mongo-formatted query object that can be passed to the backend.
 *
 * @param userFilters
 * @param groupSelection
 * @param mergeFilters
 * @param search
 * @param customRunNames
 */
export function useCombinedFilter({
  userFilters,
  groupSelection,
  mergeFilters,
  search,
  customRunNames,
}: UseCombinedFilterOptions) {
  return useMemo(
    () =>
      combinedFilter(
        userFilters,
        groupSelection,
        undefined,
        mergeFilters,
        search,
        customRunNames
      ),
    [userFilters, mergeFilters, groupSelection, search, customRunNames]
  );
}
